import { TGlobalState } from 'reducers';

export const getBookableAppointments = (state: TGlobalState) =>
  state?.bookableAppointments?.appointments;

export const getMaxAppointmentsWarning = (state: TGlobalState) =>
  state?.bookableAppointments?.maxAppointmentsWarning;
